/**
 * Solid-specific QueryClient for `apps/web`.
 *
 * Mirrors the defaults of `createStandardQueryClient` (from `@journal/shared`)
 * but instantiates the `QueryClient` class exported by `@tanstack/solid-query`
 * — required to satisfy Solid's `QueryClientProvider` type, whose
 * `QueryClient` extends the base with its own private fields.
 *
 * We keep the same values as in `apps/native` (offlineFirst, retry=2,
 * staleTime of 5 minutes) to guarantee behavioral parity between both apps.
 */

import { QueryCache, QueryClient } from "@tanstack/solid-query";
import { OFFLINE_CACHE_STALE_TIME_MS } from "./constants";

const DEFAULT_RETRY_COUNT = 2;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: "offlineFirst",
      refetchOnReconnect: true,
      retry: DEFAULT_RETRY_COUNT,
      staleTime: OFFLINE_CACHE_STALE_TIME_MS,
    },
    mutations: {
      networkMode: "offlineFirst",
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (import.meta.env.DEV) {
        console.warn("[QueryClient] error", { error, query });
      }
    },
  }),
});
